import { SKILL_TYPES } from "utils/constants";

/**
 * Extracts French department code from a postal code.
 * DOM (97x): first 3 digits (971, 972, 973, …).
 * Metropolitan France: first 2 digits.
 */
export const getDepartmentFromZipCode = (zipCode) => {
  const code = String(zipCode || "").trim();
  if (!code) return null;
  return code.startsWith("97") ? code.slice(0, 3) : code.slice(0, 2);
};

export const buildDepartmentSkills = (projectSkills, zipCode) => {
  const skills = projectSkills || {};
  if (!Object.keys(skills).includes(SKILL_TYPES.DEPARTMENT)) {
    return skills;
  }
  return {
    ...skills,
    [SKILL_TYPES.DEPARTMENT]: getDepartmentFromZipCode(zipCode),
  };
};
